module.exports = __webpack_public_path__ + "static/banner-texture-bbd8b16f6fedd2a04de59b17f6868b24.png";